import * as React from "react";
import { Container } from "react-bootstrap";
import Seo from "../components/Seo";

import Layout from "../components/Layout";
import PageFooterSections from "../components/PageFooterSections";
import Section from "../components/Section";

import { eventsPageTplData } from "../data/page-tpl-events.data";
import { getCurrentPageSeo } from "../helpers/richContentHelpers";

import PageHead from "../components/Page/PageHead";
import GetInTouch from "../components/GetInTouch";
import ArticlesEvents from "../components/ArticlesEvents";
import PastEvents from "../components/PastEvents";

const pageResources = ({ pageContext: { id } }) => {
    const seoPageData = getCurrentPageSeo(id);
    const pageData = eventsPageTplData(id);

    return (
        <Layout pageTitle={seoPageData.title}>
            <Seo post={seoPageData} />
            {/* Page head */}
            <Container>
                <PageHead {...pageData.pageHeader} />
            </Container>

            {/* Articles Section */}
            <Section>
                <Container>
                    <ArticlesEvents {...pageData.postsList} temp="events" />
                </Container>
            </Section>

            {/* Past Events Section */}
            <Section>
                <PastEvents />
            </Section>

            {/* GetInTouch Section */}
            <Section className="-mobile-full">
                <GetInTouch pageTitle={seoPageData.title} />
            </Section>

            <PageFooterSections pageData={pageData} />
        </Layout>
    );
};

export default pageResources;
